import { render } from "./dealCard.vue?vue&type=template&id=f6949f3c&scoped=true"
import script from "./dealCard.vue?vue&type=script&lang=js"
export * from "./dealCard.vue?vue&type=script&lang=js"

import "./dealCard.vue?vue&type=style&index=0&id=f6949f3c&lang=css"
import "./dealCard.vue?vue&type=style&index=1&id=f6949f3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6949f3c"]])

export default __exports__